// ** Reactstrap Imports
import { Card, CardBody, Spinner, Alert, Row, Col, Button } from 'reactstrap'
import { tokenValueTxt, n12 } from '../../helpers/formatters'
import { AlertCircle } from 'react-feather'
import { useEffect, useState } from 'react'
import * as web3Service from '../../blockchain/web3V2.service'
import { useWeb3React } from "@web3-react/core"
import { configs } from '../../blockchain/web3V2.config'
import { Contract } from "@ethersproject/contracts"
import DataTable from './DataTable'

export default function UserRewardsInfo(props) {

  const { tokenAddress, isValidAccountAddress } = props

  const [userRewardsInfo, setUserRewardsInfo] = useState({})
  const [userTokenAddress, setUserTokenAddress] = useState('')
  const [isLoading, setLoading] = useState(false)

  const { account, active, library } = useWeb3React()


  useEffect(async () => {
    if (active && account) {
      setUserTokenAddress(account)
    } else {
      setUserTokenAddress(tokenAddress)
    }
    console.log('userTokenAddress', userTokenAddress)
    console.log('tokenAddress', tokenAddress)
  }, [account, active, library, tokenAddress])

  const claimTokens = async () => {

    const { web3Config } = configs
    const tokenContractAddress = '0xB72962568345253f71A18318D67E13A282b187E6'
    const erc20ContractAbi = JSON.parse(web3Config.mainContractAbi)
    const contract = new Contract(tokenContractAddress, erc20ContractAbi, library.getSigner())
    // const erc20ContractInstance = await library.eth.Contract(erc20ContractAbi, tokenContractAddress)
    await contract.claim()
  }

  useEffect(async () => {
    try {

      setLoading(true)
      //get the token main token price in usd
      const userRewards = await web3Service.getUserRewardsDetails(userTokenAddress)
      console.log('userRewards', userRewards)
      if (userRewards) {
        setUserRewardsInfo(userRewards)
      } else {
        setUserRewardsInfo({})
      }
    } catch (error) {
      setUserRewardsInfo({})
      console.error('error while fetching rewards info ', error.message || '')
    } finally {
      setLoading(false)
    }

  }, [userTokenAddress, isValidAccountAddress])

  return (
    <Card>
      {
        isLoading ? (
          <CardBody className="data-info-widget">
            <Spinner type='grow' color='primary' />
          </CardBody>

        ) : (
          <CardBody className="data-info-widget">
            <Row className='total-user-rewards'>
              <Col sm="12" md="6" lg="3">
                <div className='user-dividend-data-container'>
                  <div className='user-divided-data-title'>
                    Total Rewards Distributed So Far
                  </div>
                  <div className='user-divided-data-value'>
                    {tokenValueTxt(userRewardsInfo ? userRewardsInfo.totalRewardsDistributed : 0.0, 0, '')} {userRewardsInfo ? userRewardsInfo.rewardsTokenSymbol : ''}
                  </div>
                </div>
              </Col>
              <Col sm="12" md="6" lg="3">
                <div className='user-dividend-data-container'>
                  <div className='user-divided-data-title'>
                    Total Rewards Distributed So Far
                  </div>
                  <div className='user-divided-data-value'>
                    ~ {tokenValueTxt(userRewardsInfo ? userRewardsInfo.totalRewardsDistributedInUSD : 0.0, 0, '')} USD
                  </div>
                </div>
              </Col>
              <Col sm="12" md="6" lg="3">
                <div className='user-dividend-data-container'>
                  <div className='user-divided-data-title'>
                    Total Pending Rewards
                  </div>
                  <div className='user-divided-data-value'>
                    {tokenValueTxt(userRewardsInfo ? userRewardsInfo.rewardTokenPendingBalance : 0.0, 0, '')} {userRewardsInfo ? userRewardsInfo.rewardsTokenSymbol : ''}
                  </div>
                </div>
              </Col>
              <Col sm="12" md="6" lg="3">
                <div className='user-dividend-data-container'>
                  <div className='user-divided-data-title'>
                    Total Pending Rewards
                  </div>
                  <div className='user-divided-data-value'>
                    ~ {tokenValueTxt(userRewardsInfo ? userRewardsInfo.rewardTokenPendingBalanceInUSD : 0.0, 0, '')} USD
                  </div>
                </div>
              </Col>
            </Row>
            {
              isValidAccountAddress ? (<Row style={{ marginTop: '30px' }} className='total-user-rewards'>
                <Col sm="12" md="6" lg="3">
                  <div className='user-dividend-data-container'>
                    <div className='user-divided-data-title'>
                      Total User Rewards So Far
                    </div>
                    <div className='user-divided-data-value'>
                      {tokenValueTxt(userRewardsInfo ? userRewardsInfo.userRewardsTotal : 0.0, 0, '')} {userRewardsInfo ? userRewardsInfo.rewardsTokenSymbol : ''}
                    </div>
                  </div>
                </Col>
                <Col sm="12" md="6" lg="3">
                  <div className='user-dividend-data-container'>
                    <div className='user-divided-data-title'>
                      Total User Rewards So Far
                    </div>
                    <div className='user-divided-data-value'>
                      ~ {tokenValueTxt(userRewardsInfo ? userRewardsInfo.userRewardsTotalInUSD : 0.0, 0, '')} USD
                    </div>
                  </div>
                </Col>
                <Col sm="12" md="6" lg="3">
                  <div className='user-dividend-data-container'>
                    <div className='user-divided-data-title'>
                      User Dividend Claimable
                    </div>
                    <div className='user-divided-data-value'>
                      {n12.format(userRewardsInfo ? userRewardsInfo.userClaimableTokenAmount : 0.0)} {userRewardsInfo ? userRewardsInfo.rewardsTokenSymbol : ''}
                    </div>
                  </div>
                </Col>
                <Col sm="12" md="6" lg="3">
                  <div className='user-dividend-data-container'>
                    <div className='user-divided-data-title'>
                      User Dividend Claimable
                    </div>
                    <div className='user-divided-data-value'>
                      ~ {tokenValueTxt(userRewardsInfo ? userRewardsInfo.userClaimableTokenAmountInUSD : 0.0, 0, '')} USD
                    </div>
                  </div>
                </Col>
              </Row>

              ) : (
                <div style={{ marginTop: '20px' }}>
                  <Alert color='primary' isOpen={true}>
                    <div className='alert-body'>
                      <AlertCircle size={15} />{' '}
                      <span className='ms-1'>
                        Please connect your wallet or enter the valid wallet address to see user specific dividends data.
                      </span>
                    </div>
                  </Alert>
                </div>
              )
            }

            {
              (userRewardsInfo && userRewardsInfo.userClaimableTokenAmount > 0) ? (<Row style={{ marginTop: '50px' }}>
                <Col sm="12" md="12" lg="12">

                  {
                    active ? (<div className='claim-your-token-container'>
                      <div className='claim-your-token-title'>
                        Claim your Rewards
                      </div>
                      <div className='claim-your-token-value'>
                        <Button color='primary' onClick={claimTokens}>Claim your Rewards</Button>
                      </div>
                    </div>) : (<div style={{ marginTop: '20px' }}>
                      <Alert color='danger' isOpen={true}>
                        <div className='alert-body'>
                          <AlertCircle size={15} />{' '}
                          <span className='ms-1'>
                            Please connect your wallet to proceed manual claim
                          </span>
                        </div>
                      </Alert>
                    </div>)
                  }

                </Col>

              </Row>

              ) : (

                userTokenAddress && userTokenAddress.length > 0 ? (<div style={{ marginTop: '20px' }}>
                  <Alert color='danger' isOpen={true}>
                    <div className='alert-body'>
                      <AlertCircle size={15} />{' '}
                      <span className='ms-1'>
                        Sorry you don't have sufficient rewards balance to claim the rewards
                      </span>
                    </div>
                  </Alert>
                </div>) : (<div></div>)
              )
            }

          </CardBody>
        )
      }
    </Card>

  )
}
